const API_CHECK = "https://freebies.flyerwrk.com/api/newsletter/check";
const API_URL = "https://freebies.flyerwrk.com/api/newsletter/download";

// const API_CHECK = "http://localhost:8080/api/newsletter/check";
// const API_URL = "http://localhost:8080/api/newsletter/download";

const emailForm = document.getElementById( "freebie-form" );
const productId = document.getElementById( "freebie-product" ).value;
const emailInput = document.getElementById( "freebie-email" );
const freebieForm = document.getElementById( "freebie-form-container" );
const unlockButton = document.getElementById( "freebie-unlock-button" );
const downloadButtonContainer = document.getElementById( "freebie-download-button-container" );
const downloadButton = document.getElementById( "freebie-download-button" );
const removeCookieContainer = document.getElementById("freebie-remove-cookie-container");
const removeCookie = document.getElementById("freebie-remove-cookie");

emailForm.addEventListener( "submit", ( event ) => {
	event.preventDefault();

	const email = emailInput.value;

	fetch( API_CHECK, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify( {
				email: email,
				product: productId,
			} ),
		} )
		.then( ( response ) => response.json() )
		.then( ( response ) => {
			if ( response.status == "ok" ) {
				unlockButton.style.display = "none";
				freebieForm.style.display = "none";
				downloadButtonContainer.style.display = "block";
				removeCookieContainer.style.display = "block";

				setCookie( "freebie-email", email, 14 );
			} else {
				console.log( "no subscribe" )
				window.location.href = "https://www.flyerwrk.com/pages/newsletter";
			}
		} )
		.catch( ( error ) => {
			console.error( error );
		} );
} );

downloadButton.addEventListener( "click", ( event ) => {
	event.preventDefault();

	const email = emailInput.value;

	fetch( API_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify( {
				email: email,
				product: productId,
			} ),
		} )
		.then( ( response ) => response.json() )
		.then( ( response ) => {
			if ( response.status == "ok" ) {
				downloadButton.href = response.url;
				window.location.href = response.url;
				
				setCookie( "freebie-email", email, 14 );
				disableButton(downloadButton);
                sa_event(response.name);
			} else {
				console.log( "no subscribe" )
				window.location.href = "https://www.flyerwrk.com/pages/newsletter";
			}
		} )
		.catch( ( error ) => {
			console.error( error );
		} );
} );

removeCookie.addEventListener("click", () => {
	deleteCookie("freebie-email");
	
	unlockButton.style.display = "block";
	freebieForm.style.display = "block";
	
	removeCookieContainer.style.display = "none";
	downloadButtonContainer.style.display = "none";
} );

const email = getCookie( "freebie-email" );
if ( email ) {
	emailInput.value = email;
	
	unlockButton.style.display = "none";
	freebieForm.style.display = "none";
	
	downloadButtonContainer.style.display = "block";
	removeCookieContainer.style.display = "block";
}

function setCookie( name, value, days ) {
	const expires = new Date( Date.now() + days * 24 * 60 * 60 * 1000 );
	document.cookie = name + "=" + value + ";expires=" + expires.toUTCString() + ";path=/";
}

function getCookie( name ) {
	const matches = document.cookie.match( new RegExp( "(?:^|; )" + name.replace( /([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1" ) + "=([^;]*)" ) );
	return matches ? decodeURIComponent( matches[ 1 ] ) : undefined;
}

function deleteCookie( name ) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

function disableButton(button) {
	button.disabled = true;
	setTimeout(() => {
		button.disabled = false;
	}, 10000);
}